import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';
import { heightExtendingError } from '../../../styles/mixins';

export const useQuoteRoutingDialogStyles = createStyles(({ token }) => ({
  quoteRoutingDialog: {
    '&&': {
      ...heightExtendingError(token),

      '.ShipmentDetails': {
        marginTop: ThemeSpaces.SPACE_NORM_20,
        marginLeft: ThemeSpaces.SPACE_NORM_60,
        marginRight: ThemeSpaces.SPACE_NORM_60,
        paddingRight: 0,

        '.ant-card-body': {
          paddingTop: 0,
        },
      },

      '.airline-icon': {
        marginRight: ThemeSpaces.SPACE_NORM0_5,
      },
    },
  },

  // Applied directly (alongside the shared `shipmentInfoTitle` base class)
  // to this file's own two "shipment title" divs — `&&` outranks that base.
  shipmentTitleOverride: {
    '&&&': {
      fontSize: 26,
      color: ThemeColors.COLOR_GREY3,
    },
  },

  // `&&` self-doubles so this outranks useQuoteStyles' shared
  // `quoteSummaryHeaderCard` (equal specificity otherwise).
  quoteSummaryHeaderCardOverride: {
    '&&': {
      boxShadow: `1px 1px 6px 0 ${ThemeColors.COLOR_GREY8_1}`,
      display: 'flex',
      alignItems: 'center',

      'h1, h2': {
        margin: 0,
      },

      '.ant-card-body': {
        flexGrow: 1,
      },
    },
  },

  // Applied directly (alongside the shared `shipmentStatus` base class) to
  // this file's own two "shipment status" titles — `&&` outranks that base.
  shipmentStatusOverride: {
    '&&&': {
      color: ThemeColors.COLOR_GREY_BLUISH2,
      fontSize: ThemeFont.FONT_SIZE_20,

      '.text-highlight': {
        fontSize: 18,
        fontFamily: token.fontFamily,
      },
    },
  },

  shipmentStatusRightOverride: {
    textAlign: 'right',
  },

  quoteRoutingHeaderMain: {
    '&&': {
      marginBottom: 0,
    },
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  backButton: {
    '&&': {
      color: `${ThemeColors.COLOR_GREY3} !important`,
      fontFamily: token.fontFamily,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      fontWeight: 500,
      fontStyle: 'italic',
      letterSpacing: -0.2,
      textAlign: 'right',
      lineHeight: '18px',

      '&& .fas': {
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        color: token.colorPrimary,
      },
    },
  },

  sectionRow: {
    marginTop: ThemeSpaces.SPACE_NORM,
    marginBottom: ThemeSpaces.SPACE_NORM,
  },

  routingsSummaryReviewRow: {
    justifyContent: 'space-between',
  },

  quoteBackBtnWrap: {
    position: 'relative',
  },

  sectionCard: {
    backgroundColor: ThemeColors.COLOR_WHITE2,
    boxShadow: `1px 1px 6px 0 ${ThemeColors.COLOR_GREY8_1}`,
    marginBottom: ThemeSpaces.SPACE_NORM_25,

    '.fa-exclamation-triangle': {
      fontSize: 21,
      color: ThemeColors.COLOR_ORANGE3,
      paddingRight: ThemeSpaces.SPACE_NORM0_5,
    },
  },

  sectionCardSm: {
    '.ant-card-body': {
      paddingBottom: ThemeSpaces.SPACE_MD,
    },
  },

  sectionBetweenHeader: {
    color: token.colorPrimary,
    fontSize: token.fontSize,
    fontWeight: 700,
    fontFamily: ThemeFont.FONT_CONDENSED,
    textTransform: 'uppercase',
    marginBottom: ThemeSpaces.SPACE_NORM0_5,
    marginTop: ThemeSpaces.SPACE_NORM0_5,
    lineHeight: 1,
  },

  sectionBetweenHeaderAlt: {
    color: ThemeColors.COLOR_BLUE2,
    fontSize: token.fontSizeSM,
    fontWeight: 500,
    textTransform: 'uppercase',
  },

  alternateRoutingRow: {
    '&:not(:last-child)': {
      marginBottom: ThemeSpaces.SPACE_NORM_20,
    },
  },

  routingFilterRow: {
    marginBottom: ThemeSpaces.SPACE_NORM_15,
  },

  routingsSortLabel: {
    color: 'rgba(92, 102, 112, 1)',
    fontFamily: token.fontFamily,
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    fontWeight: 500,
    fontStyle: 'italic',
    lineHeight: '18px',
    position: 'relative',

    '.MonitorSearchFilters-SortIcon': {
      left: -30,

      '&.active': {
        boxShadow: 'none',
        borderLeft: 'none',
      },
    },

    '&&& .IconButton-Icon': {
      fontSize: token.fontSize,
      marginRight: ThemeSpaces.SPACE_NORM0_5,
    },
  },

  routingSortCol: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  // Label modifier composed with MonitorSearchFilters' `popupLabel` on the sort popover.
  sortPopupLabelNoBackground: {
    '&&&': {
      background: 'none',
      color: 'inherit',
      float: 'right',
    },
  },

  // Overlay modifier composed with MonitorSearchFilters' `popup` on the sort popover.
  sortPopupOverlayFixedWidth: {
    '&&': {
      '.ant-popover-inner': {
        width: 135,
      },
    },
  },
}));
